import React, { useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CapImg from "../../assets/img/cap.png";
import {Link } from "react-router-dom";
import megaphoneImg from "../../assets/img/Megaphone.png";
import {
  Container,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Button,
  Carousel,
  Row,
  Col,
  Image,
} from "react-bootstrap";
import Bandeau from 'components/Etudes/Bandeau';
import Breadcrumb from 'components/breadcrumb/breadcrumb';
import MainTitle from 'components/General/MainTitle';
import BgShape from 'components/General/BgShape';
import { useParams } from 'react-router-dom';
import samples from 'data/SamplePages';
import CoverImg from 'components/General/CoverImg';
import { fetchAPIProjects,fetchAPIBourses } from 'services/institut-national'
import { getAsset } from "services/assets";
import parse from 'html-react-parser'
import EventsGrid from 'components/General/EventsGrid';
import { LanguageContext } from "services/LanguageContext";


export default function Support() {
  const [projet, setProjet] = React.useState();
  const [bourse, setBourse] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const { language } = useContext(LanguageContext);
    React.useEffect(()=>{
        window.scrollTo(0, 0)
    },[])
    React.useEffect( () => {
      function fetchData() {
        fetchAPIProjects().then((items)=>{
          //const res = await fetchAPIprojetDetails(results.posts[0].id)
          var el=items.items[0]?.data;
          //console.log(el);
          
            setProjet(el);
        
          
        });
        fetchAPIBourses().then((items)=>{
          //const res = await fetchAPIbourseDetails(results.posts[0].id)
          //console.log(items)
          var el=items.items[0]?.data;
          //console.log(el);
          
            setBourse(el);
        
          
        });
      }
        
      fetchData();
  }, []);
  try{var text = parse(projet?.["Description-courte"]?.iv??projet?.["Description-courte"][language??'fr'])}catch($){
    text = projet?.["Description-courte"][language??'fr']
  }
  try{var boursetxt = parse(bourse?.["Description-courte"]?.iv??bourse?.["Description-courte"][language??'fr'])}catch($){
    boursetxt = bourse?.["Description-courte"]?bourse?.["Description-courte"][language??'fr']:""??''
  }
  return (
    <Container fluid className="container-lg" dir={language==='ar'?"rtl":""}>
      <Row >
        <Col style={{ position: "relative" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "46px",marginTop: "28px", fontWeight:"600" }}>
            L’IFA soutient vos projets
          </h1>
        </Col>
      </Row>
      <Row className="py-4">
        <Col md={5}>{supprtSvg}</Col>
        <Col md={6} >
          <Row style={{ alignContent: "center", height: "50%" }} className="mb-3">
            <Col
              md={2}
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Link to="/institut/bourses">
              <Button
                style={{
                  height: "80px",
                  width: "80px",
                  marginBottom: "16px",
                  fontSize: "22px",
                  borderColor: "#3558a2",
                  color: "#3558a2",
                  borderRadius: "50%",
                }}
                variant="outline-light"
              >
                <img src={CapImg} style={{
                  height: "50px",
                  width: "50px",
                }}></img>
              </Button>{" "}
              </Link>
            </Col>
            <Col md={8} style={{ textAlign: "initial" }}>
            <Link to="/institut/bourses">
              <h1
                style={{
                  fontSize: "1.5rem",
                  textAlign: "initial",
                }}
              >
                BOURSES & CANDIDATURES
              </h1>
              </Link>
              <br></br>
              <p
                style={{
                  fontSize: "1.1rem",
                  textAlign: "initial",
                  marginBottom: 0,
                }}
              >
                {boursetxt??''}
              </p>
              <Link to="/institut/bourses">
              <Button
                variant="link"
                style={{
                  color: "black",
                  textDecorationColor: "#ffed00",
                  textDecorationThickness: "3px",
                  marginLeft: "-12px",
                }}
              >
                En savoir +
              </Button>
              </Link>
            </Col>
          </Row>
          <Row style={{ alignContent: "center", height: "50%" }}>
            <Col
              md={2}
              style={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <Link to="/institut/appels-projets">
              <Button
                style={{
                  height: "80px",
                  width: "80px",
                  marginBottom: "16px",
                  fontSize: "22px",
                  borderColor: "#3558a2",
                  color: "#3558a2",
                  borderRadius: "50%",
                }}
                variant="outline-light"
              >
                <img src={megaphoneImg} style={{
                  height: "50px",
                  width: "50px",
                }}></img>
              </Button>{" "}
              </Link>
            </Col>
            <Col md={8} style={{ textAlign: "initial" }}>
            <Link to="/institut/appels-projets">
              <h1
                style={{
                  fontSize: "1.5rem",
                  textAlign: "initial",
                  textTransform:"uppercase"
                }}
              >
                Appels à projets
              </h1>
              </Link>
              <br></br>
              <p
                style={{
                  fontSize: "1.1rem",
                  textAlign: "initial",
                  marginBottom: 0,
                }}
              >
               {text??""}
              </p>
              <Link to="/institut/appels-projets">
              <Button
                variant="link"
                style={{
                  color: "black",
                  textDecorationColor: "#ffed00",
                  textDecorationThickness: "3px",
                  marginLeft: "-12px",
                }}
              >
                En savoir +
              </Button>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </Container>
  );
}

const supprtSvg = (
  <svg
    style={{ width:"90%" }}
    //width="1819"
    //height="1100"
    viewBox="0 0 1819 1100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1150.77 185.73C1131.16 136.848 1047.72 162.597 1047.72 162.597C1047.72 162.597 1000.16 257.715 983.56 261.789C966.958 265.863 1008.32 172.535 1008.32 172.535C975.31 173.197 896.808 222.89 896.808 222.89C896.808 222.89 914.155 325.345 897.06 325.211C879.965 325.077 886.334 233.711 886.334 233.711C855.854 246.87 830.685 287.128 830.685 287.128C800.857 351.387 885.01 386.328 885.01 386.328C885.01 386.328 890.255 421.964 872.95 465.567C869.724 472.519 867.157 479.758 865.283 487.189L873.895 486.183C874.329 483.794 874.847 481.477 875.45 479.232C875.449 479.225 875.45 479.218 875.452 479.211C875.454 479.204 875.458 479.198 875.462 479.192C875.47 479.159 875.48 479.128 875.489 479.092C875.923 477.692 876.549 475.703 877.336 473.275V473.266C877.336 473.266 877.336 473.26 877.336 473.255C879.364 467.803 880.696 463.794 881.499 460.919C881.5 460.91 881.5 460.901 881.499 460.892C887.49 443.821 896.381 421.452 903.439 416.153C902.511 415.016 901.736 413.762 901.134 412.422L903.439 416.153C921.879 445.981 996.206 442.62 1036.29 429.403C1076.37 416.186 1057.11 406.712 1032.8 390.521C1008.48 374.33 962.73 384.698 948.178 378.937C933.626 373.176 952.77 363.474 980.395 362.376C1008.02 361.278 1024.91 387.023 1069.63 386.057C1114.35 385.091 1138.31 298.066 1138.31 298.066C1108.88 311.102 1052.15 300.677 1048.81 290.406C1045.48 280.135 1126.68 271.706 1138.94 267.073C1151.21 262.44 1170.38 234.616 1150.77 185.73Z"
      fill="#AFCDFB"
    />
    <path
      d="M1720.43 859.122C1706.25 793.896 1596.52 808.522 1596.52 808.522C1596.52 808.522 1517.01 917.4 1495.4 918.999C1473.79 920.598 1545.18 812.653 1545.18 812.653C1503.78 806.532 1395.18 852.122 1395.18 852.122C1395.18 852.122 1395.24 983.822 1373.91 980.059C1352.57 976.296 1379.81 863.44 1379.81 863.44C1338.93 873.475 1298.98 918.488 1298.98 918.488C1248.14 992.531 1345.95 1053.91 1345.95 1053.91C1345.95 1053.91 1345.63 1069.55 1339.17 1092.72C1338.61 1094.75 1337.99 1096.85 1337.31 1099.01H1357.56C1359.08 1097.46 1360.81 1096.13 1362.71 1095.07C1363.25 1096.42 1363.89 1097.74 1364.6 1099.01H1539.21C1537.04 1096.98 1534.77 1094.9 1532.44 1092.72C1531.57 1091.91 1530.68 1091.09 1529.79 1090.25C1502.82 1064.9 1443.44 1068.24 1426.47 1057.97C1409.5 1047.71 1435.47 1039.61 1470.24 1044.05C1505 1048.48 1520.68 1084.22 1576.77 1092.43C1577.63 1092.56 1578.49 1092.66 1579.35 1092.72C1581.93 1092.94 1584.53 1092.94 1587.1 1092.72C1638.67 1088.18 1681.18 996.912 1681.18 996.912C1641.64 1007.01 1572.94 982.038 1570.94 968.501C1568.93 954.964 1672.2 961.51 1688.52 958.301C1704.83 955.092 1734.63 924.346 1720.43 859.122ZM1362.7 1095.05C1362.26 1094.3 1361.88 1093.52 1361.57 1092.72C1361.2 1091.8 1360.88 1090.87 1360.62 1089.92C1360.99 1090.83 1361.37 1091.77 1361.75 1092.72C1362.06 1093.48 1362.38 1094.25 1362.7 1095.05Z"
      fill="#C7DCFB"
    />
    <path
      d="M3.77939 322.494C16.1644 274.959 96.4074 288.982 96.4074 288.982C96.4074 288.982 151.615 371.407 167.457 373.226C183.299 375.045 134.032 293.549 134.032 293.549C164.657 290.282 243.147 327.041 243.147 327.041C243.147 327.041 239.162 423.88 254.964 421.748C270.766 419.616 254.113 335.822 254.113 335.822C283.866 344.422 311.896 378.711 311.896 378.711C347.064 434.665 273.311 476.88 273.311 476.88C273.311 476.88 272.656 510.469 293.803 548.78C297.608 554.833 300.835 561.23 303.443 567.886L295.356 567.966C294.674 565.806 293.921 563.724 293.099 561.718C293.099 561.711 293.098 561.705 293.095 561.698C293.092 561.692 293.088 561.686 293.083 561.681C293.071 561.652 293.058 561.624 293.047 561.595C292.48 560.352 291.667 558.584 290.652 556.429V556.422C290.652 556.422 290.652 556.422 290.652 556.411C288.134 551.604 286.429 548.052 285.352 545.485C285.348 545.478 285.346 545.47 285.344 545.461C277.79 530.369 266.929 510.715 259.774 506.642C260.499 505.481 261.069 504.23 261.468 502.92L259.774 506.642C246.224 536.408 177.054 542.03 138.411 534.511C99.7684 526.992 116.47 515.961 137.062 498.122C157.654 480.283 201.208 484.503 213.994 477.461C226.78 470.419 207.924 463.693 182.234 465.923C156.544 468.153 143.943 493.959 102.451 498.323C60.9594 502.687 28.5434 424.972 28.5434 424.972C57.3074 433.578 108.57 417.266 110.45 407.372C112.33 397.478 36.1994 399.216 24.3034 396.372C12.4074 393.528 -8.60561 370.03 3.77939 322.494Z"
      fill="#AFCDFB"
    />
    <path
      d="M1327.13 1078.35L377.291 1092.45C373.728 1092.5 370.251 1091.36 367.421 1089.19C364.59 1087.03 362.572 1083.97 361.691 1080.52L180.545 368.545C179.953 366.212 179.901 363.775 180.392 361.419C180.882 359.062 181.904 356.849 183.378 354.947C184.853 353.045 186.742 351.503 188.901 350.44C191.06 349.378 193.434 348.821 195.84 348.813L1148.24 344.753C1151.77 344.736 1155.21 345.902 1158.01 348.064C1160.8 350.226 1162.8 353.261 1163.67 356.686L1342.27 1058.62C1342.86 1060.94 1342.91 1063.36 1342.43 1065.71C1341.95 1068.05 1340.94 1070.26 1339.49 1072.16C1338.03 1074.06 1336.16 1075.6 1334.02 1076.67C1331.88 1077.75 1329.53 1078.32 1327.13 1078.35Z"
      fill="#162B4C"
    />
    <path
      d="M1334.92 1078.18L396.093 1082.18C385.793 1082.22 371.282 1088.77 368.747 1078.8L199.056 376.699C198.219 373.398 198.144 369.949 198.839 366.614C199.534 363.279 200.98 360.147 203.066 357.455C205.153 354.763 207.826 352.582 210.882 351.077C213.938 349.573 217.297 348.785 220.703 348.773L1159.53 344.773C1164.53 344.75 1169.4 346.4 1173.35 349.46C1177.31 352.52 1180.13 356.815 1181.37 361.661L1356.57 1050.25C1357.41 1053.55 1357.48 1057 1356.79 1060.34C1356.09 1063.67 1354.64 1066.8 1352.56 1069.5C1350.47 1072.19 1347.8 1074.37 1344.74 1075.87C1341.68 1077.38 1338.33 1078.17 1334.92 1078.18Z"
      fill="#233862"
    />
    <path
      d="M1319.11 1051.68L401.325 1055.56C398.964 1055.56 396.668 1054.78 394.799 1053.34C392.931 1051.9 391.596 1049.87 391.006 1047.59L231.812 427.512L218.456 375.465C218.055 373.902 218.016 372.268 218.342 370.688C218.668 369.108 219.351 367.623 220.338 366.346C221.325 365.07 222.59 364.036 224.037 363.322C225.485 362.609 227.076 362.235 228.689 362.23L1146.47 358.354C1148.84 358.344 1151.13 359.122 1153 360.566C1154.87 362.009 1156.21 364.035 1156.79 366.323L1329.34 1038.45C1329.74 1040.01 1329.78 1041.64 1329.45 1043.22C1329.13 1044.8 1328.44 1046.29 1327.46 1047.56C1326.47 1048.84 1325.21 1049.87 1323.76 1050.58C1322.31 1051.3 1320.72 1051.67 1319.11 1051.68Z"
      fill="#9CC4FF"
    />
    <path
      d="M1172.5 427.512H231.812L218.456 375.465C218.055 373.902 218.016 372.268 218.342 370.688C218.668 369.108 219.351 367.623 220.338 366.346C221.325 365.07 222.59 364.036 224.037 363.322C225.485 362.609 227.076 362.235 228.689 362.23L1146.47 358.354C1148.84 358.344 1151.13 359.122 1153 360.566C1154.87 362.009 1156.21 364.035 1156.79 366.323L1172.5 427.512Z"
      fill="#CFE3FF"
    />
    <path
      d="M1534.37 765.195C1534.37 765.195 1387.53 714.304 1074.62 775.136C977.809 793.96 856.68 832.036 726.118 864.327L648.907 594.671C649.619 594.489 650.373 594.295 651.156 594.092C690.63 583.938 822.72 547.234 975.763 490.356C1113.93 439.017 1269.95 372.136 1384.72 242.556L1534.37 765.195Z"
      fill="#ED7D2B"
    />
    <path
      d="M1495.59 629.738C1446.12 618.029 1299.45 594.459 1046.07 643.379C947.472 662.416 824.172 701.233 691.221 734.033L651.156 594.093C690.63 583.939 822.72 547.234 975.763 490.356C1113.93 439.017 1269.95 372.136 1384.72 242.556L1495.59 629.738Z"
      fill="#F99746"
    />
    <path
      d="M1548.31 783.266C1546.16 783.882 1543.86 783.618 1541.9 782.534C1539.95 781.45 1538.5 779.633 1537.89 777.484L1379.96 225.9C1379.65 224.836 1379.56 223.723 1379.69 222.623C1379.81 221.524 1380.16 220.46 1380.69 219.493C1381.23 218.526 1381.95 217.674 1382.82 216.986C1383.69 216.299 1384.68 215.789 1385.75 215.485C1387.9 214.871 1390.2 215.134 1392.16 216.219C1394.11 217.303 1395.56 219.119 1396.17 221.268L1554.1 772.852C1554.41 773.917 1554.5 775.03 1554.37 776.13C1554.25 777.229 1553.9 778.293 1553.37 779.26C1552.83 780.227 1552.11 781.079 1551.24 781.766C1550.37 782.454 1549.38 782.963 1548.31 783.266Z"
      fill="#ED7D2B"
    />
    <path
      d="M567.919 910.001L726.491 864.708L649.206 594.777L490.634 640.069C487.536 640.963 484.917 643.046 483.35 645.865C481.783 648.684 481.396 652.008 482.273 655.111L552.863 901.65C553.762 904.748 555.85 907.364 558.67 908.929C561.491 910.493 564.816 910.879 567.919 910.001Z"
      fill="#D66316"
    />
    <path
      d="M1018.18 1053.23L877.368 1053.83L807.11 905.219L781.15 850.292L781.201 850.271L909.617 809.777L1018.18 1053.23Z"
      fill="#F99746"
    />
    <path
      d="M1018.18 1053.23L877.368 1053.83L807.11 905.219L935.791 868.465L1018.18 1053.23Z"
      fill="#ED7D2B"
    />
    <path
      d="M1676.71 277.662C1678.24 279.535 1678.96 281.936 1678.72 284.342C1678.49 286.747 1677.3 288.96 1675.44 290.496L1539.75 401.618C1537.87 403.145 1535.47 403.868 1533.06 403.63C1530.66 403.393 1528.44 402.213 1526.9 400.348C1525.37 398.476 1524.65 396.075 1524.89 393.67C1525.12 391.264 1526.3 389.052 1528.17 387.515L1663.86 276.391C1665.74 274.865 1668.14 274.142 1670.55 274.38C1672.95 274.618 1675.17 275.798 1676.71 277.662Z"
      fill="#F99746"
    />
    <path
      d="M1756.83 562.891C1756.58 565.297 1755.39 567.507 1753.52 569.039C1751.65 570.57 1749.25 571.3 1746.84 571.067L1572.22 553.812C1569.81 553.569 1567.6 552.384 1566.07 550.515C1564.54 548.647 1563.8 546.247 1564.03 543.84C1564.28 541.435 1565.47 539.225 1567.34 537.693C1569.21 536.161 1571.61 535.431 1574.02 535.663L1748.63 552.918C1751.04 553.161 1753.25 554.346 1754.79 556.215C1756.32 558.084 1757.06 560.484 1756.83 562.891Z"
      fill="#F99746"
    />
    <path
      d="M1818.85 418.873C1819.28 421.253 1818.74 423.703 1817.36 425.689C1815.99 427.676 1813.88 429.036 1811.5 429.473L1566.83 473.93C1564.45 474.357 1562 473.824 1560.01 472.449C1558.02 471.074 1556.65 468.968 1556.21 466.59C1555.79 464.211 1556.32 461.761 1557.7 459.775C1559.08 457.788 1561.18 456.428 1563.56 455.99L1808.23 411.53C1810.62 411.104 1813.07 411.637 1815.06 413.013C1817.05 414.389 1818.41 416.495 1818.85 418.873Z"
      fill="#F99746"
    />
    <path
      d="M1073.86 1059.6C1073.86 1059.6 1073.86 1050.11 1075.22 1046.96C1076.57 1043.8 1081.53 1030.97 1081.53 1030.97H1100.93C1100.93 1030.97 1104.54 1042.68 1104.77 1046.51C1104.99 1050.34 1104.77 1059.6 1104.77 1059.6L1073.86 1059.6Z"
      fill="#233862"
    />
    <path
      d="M1197.01 1059.6C1197.01 1059.6 1197.01 1050.11 1195.66 1046.96C1194.3 1043.8 1189.34 1030.97 1189.34 1030.97H1169.95C1169.95 1030.97 1166.34 1042.68 1166.11 1046.51C1165.89 1050.34 1166.11 1059.6 1166.11 1059.6L1197.01 1059.6Z"
      fill="#233862"
    />
    <path
      d="M1119.31 527.305C1119.31 527.305 1118.62 548.422 1115.92 557.882L1094.5 572.805L1175.12 584.857L1155.9 558.322C1155.9 558.322 1150.09 530.008 1153.14 519.533C1156.18 509.058 1119.31 527.305 1119.31 527.305Z"
      fill="#B16A3E"
    />
    <path
      d="M1119.19 530.22C1119.19 530.213 1125.57 545.55 1137.57 545.212C1149.58 544.874 1152.32 531.312 1152.32 531.312L1119.19 530.22Z"
      fill="#98582E"
    />
    <path
      d="M1112.02 517.81C1112.02 517.81 1108.14 498.473 1105.44 492.617C1102.73 486.761 1100.47 460.631 1130.47 459.28C1130.47 459.28 1141.97 460.631 1148.29 456.802C1148.29 456.802 1148.29 460.631 1146.71 461.983C1150.09 461.388 1153.57 461.676 1156.81 462.82C1160.05 463.965 1162.94 465.927 1165.2 468.515C1173.32 477.525 1159.79 509.061 1160.46 516.494L1112.02 517.81Z"
      fill="#2C3A64"
    />
    <path
      d="M1136.2 539.289C1127.5 539.136 1111.48 527.563 1111.48 513.232V490.868C1111.48 485.636 1115.14 481.354 1119.6 481.354H1152.8C1157.27 481.354 1160.92 485.636 1160.92 490.868V511.968C1160.92 526.994 1146.18 539.465 1136.2 539.289Z"
      fill="#B16A3E"
    />
    <path
      d="M1111.48 502.809C1111.48 502.809 1111.53 489.372 1122.18 487.309C1132.84 485.246 1156.69 493.859 1160.07 484.06C1163.45 474.261 1113.97 474.431 1111.48 480.681C1108.99 486.931 1111.48 502.809 1111.48 502.809Z"
      fill="#2C3A64"
    />
    <path
      d="M1076.3 731.166C1076.3 731.166 1079.69 834.666 1074.62 893.714C1069.54 952.762 1074.65 1034.95 1074.65 1034.95C1074.65 1034.95 1090.88 1043.88 1108.47 1034.95C1108.47 1034.95 1127.76 920.864 1127.64 893.714C1127.51 864.799 1148.64 735.678 1148.64 735.678L1076.3 731.166Z"
      fill="#2B478B"
    />
    <path
      d="M1196.31 1034.94C1196.31 1034.94 1180.08 1043.88 1162.49 1034.94C1162.49 1034.94 1143.2 920.863 1143.33 893.711C1143.38 881.501 1139.65 851.411 1135.31 820.731C1129.38 778.759 1122.33 735.68 1122.33 735.68L1197.47 730.991C1197.47 730.991 1191.27 834.664 1196.35 893.711C1201.43 952.758 1196.31 1034.94 1196.31 1034.94Z"
      fill="#2B478B"
    />
    <path
      d="M1196.57 748.384C1196.57 748.384 1164.54 754.584 1135.31 754.584C1122.72 754.427 1110.15 753.467 1097.68 751.712C1085.49 750.097 1076.75 748.387 1076.75 748.387C1076.75 748.387 1070.26 748.955 1074.09 716.972C1077.01 692.631 1076.09 670.655 1075.45 648.044C1075.37 645.53 1075.42 642.557 1075.58 639.244C1076.83 612.883 1084.81 565.426 1090.89 562.878C1090.89 562.878 1099.94 559.52 1115.92 557.884C1115.92 558.196 1125.19 571.737 1136.2 573.258C1143.04 570.558 1148.41 568.251 1155.9 558.324C1166.32 559.549 1176.64 561.536 1186.77 564.27C1186.77 564.27 1187.92 569.298 1192.27 656.524C1193.99 691.073 1205.79 748.498 1196.57 748.384Z"
      fill="white"
    />
    <path
      d="M1143.33 893.711C1143.38 881.501 1139.65 851.411 1135.31 820.731C1139.81 802.404 1150.77 784.767 1150.77 784.767C1164.64 823.622 1143.33 893.711 1143.33 893.711Z"
      fill="#233862"
    />
    <path
      d="M1045.84 666.706C1045.08 667.341 1047.74 673.936 1051.66 682.532C1059.74 700.189 1073.16 726.266 1073.16 726.266C1072.13 730.34 1070.77 734.322 1069.09 738.173C1046.52 720.461 1031.97 705.392 1022.68 693.836C1009.62 677.585 1006.94 668.266 1006.94 668.266C1057.2 566.093 1092.57 562.326 1092.57 562.326L1088.39 629.849C1088.39 629.849 1048.17 664.773 1045.84 666.706Z"
      fill="white"
    />
    <path
      d="M1070.48 727.552C1070.48 727.552 1082.66 716.29 1087.62 722.597C1092.58 728.904 1093.49 738.815 1089.65 738.139C1085.82 737.463 1077.92 733.859 1076.8 735.661C1075.67 737.463 1070.62 740.908 1069.08 738.172C1067.55 735.436 1070.48 727.552 1070.48 727.552Z"
      fill="#B16A3E"
    />
    <path
      d="M1073.16 726.267C1072.13 730.341 1070.77 734.323 1069.09 738.174C1046.52 720.462 1031.96 705.393 1022.67 693.837C1029.67 693.317 1039.9 690.817 1051.66 682.537C1059.74 700.189 1073.16 726.267 1073.16 726.267Z"
      fill="#B16A3E"
    />
    <path
      d="M1267.26 668.267C1267.26 668.267 1264.58 677.586 1251.52 693.837C1242.23 705.393 1227.68 720.462 1205.11 738.174C1203.43 734.322 1202.07 730.34 1201.04 726.267C1201.04 726.267 1214.45 700.189 1222.53 682.533C1226.46 673.933 1229.12 667.342 1228.36 666.707C1226.55 665.207 1201.98 643.886 1191.02 634.379L1185.81 629.851L1183.3 563.33C1183.3 563.33 1217 566.094 1267.26 668.267Z"
      fill="white"
    />
    <path
      d="M1203.71 727.552C1203.71 727.552 1191.53 716.29 1186.57 722.597C1181.61 728.904 1180.71 738.815 1184.54 738.139C1188.38 737.463 1196.27 733.859 1197.4 735.661C1198.52 737.463 1203.58 740.908 1205.11 738.172C1206.64 735.436 1203.71 727.552 1203.71 727.552Z"
      fill="#B16A3E"
    />
    <path
      d="M1201.03 726.267C1202.07 730.34 1203.43 734.323 1205.11 738.174C1227.68 720.462 1242.23 705.393 1251.52 693.837C1244.52 693.317 1234.29 690.817 1222.53 682.537C1214.45 700.189 1201.03 726.267 1201.03 726.267Z"
      fill="#B16A3E"
    />
    <path
      d="M1117.04 552.73C1115.92 553.265 1114.92 554.038 1114.13 554.995C1113.34 555.953 1112.76 557.072 1112.45 558.274C1112.45 558.274 1126.81 573.027 1136.2 573.253L1117.04 552.73Z"
      fill="#FCDD00"
    />
    <path
      d="M1136.2 573.256L1154.74 551.988C1154.74 551.988 1158.56 554.503 1158.51 558.641C1158.51 558.642 1144.17 573.819 1136.2 573.256Z"
      fill="#FCDD00"
    />
    <path
      d="M1132.86 571.691C1132.86 571.691 1118.71 693.665 1123.64 708.533C1125.86 715.112 1128.75 721.445 1132.27 727.433C1132.71 728.192 1133.34 728.822 1134.11 729.259C1134.87 729.696 1135.73 729.924 1136.61 729.923C1137.49 729.921 1138.35 729.688 1139.11 729.248C1139.87 728.808 1140.51 728.176 1140.95 727.415C1144.7 720.901 1149.61 711.473 1149.61 706.69C1149.61 698.94 1138.88 571.59 1138.88 571.59L1132.86 571.691Z"
      fill="#FEEB00"
    />
    <path
      d="M1129.16 565.711C1129.16 565.711 1137.71 564.855 1142.91 565.383C1143.15 565.409 1143.38 565.493 1143.57 565.628C1143.77 565.763 1143.93 565.944 1144.04 566.156C1144.15 566.368 1144.2 566.604 1144.2 566.842C1144.19 567.08 1144.13 567.314 1144.01 567.521C1142.55 570.144 1139.58 574.692 1136.46 574.692C1132.09 574.692 1125.28 566.013 1129.16 565.711Z"
      fill="#FCDD00"
    />
    <path
      d="M1129.27 524.884C1130.16 525.993 1131.3 526.885 1132.59 527.496C1133.88 528.107 1135.28 528.421 1136.71 528.414C1138.06 528.397 1139.39 528.069 1140.6 527.458C1141.81 526.846 1142.86 525.965 1143.67 524.884C1143.67 524.884 1135.68 523.576 1129.27 524.884Z"
      fill="white"
    />
    <path
      d="M1158.05 502.415C1157.44 501.738 1156.69 501.202 1155.86 500.848C1155.02 500.493 1154.12 500.328 1153.21 500.363H1143.05C1141.12 500.363 1139.77 500.919 1139.04 502.013C1138.71 502.519 1138.52 503.097 1138.47 503.696C1136.98 503.359 1135.43 503.386 1133.95 503.775C1133.91 503.148 1133.71 502.542 1133.37 502.012C1132.64 500.918 1131.29 500.362 1129.36 500.362H1119.19C1118.29 500.327 1117.38 500.492 1116.55 500.847C1115.71 501.202 1114.96 501.737 1114.36 502.414C1113.87 503.037 1113.53 503.763 1113.37 504.537C1113.2 505.311 1113.22 506.112 1113.41 506.879C1114.57 512.614 1121.18 513.348 1124.49 513.348C1125.11 513.351 1125.72 513.323 1126.34 513.264C1129.43 513.257 1131.61 511.495 1133.19 507.72C1133.62 506.73 1133.88 505.677 1133.96 504.603C1135.42 504.185 1136.97 504.153 1138.44 504.511C1138.52 505.617 1138.78 506.702 1139.21 507.72C1140.8 511.495 1142.97 513.256 1146.07 513.264C1146.68 513.323 1147.3 513.352 1147.92 513.348C1151.22 513.348 1157.84 512.614 1158.99 506.879C1159.19 506.112 1159.2 505.311 1159.04 504.537C1158.87 503.764 1158.53 503.038 1158.05 502.415ZM1132.57 507.464C1131.11 510.964 1129.12 512.598 1126.32 512.598H1126.28C1124.4 512.776 1122.5 512.687 1120.65 512.334C1116.87 511.568 1114.66 509.688 1114.07 506.745C1113.89 506.075 1113.88 505.374 1114.02 504.697C1114.16 504.019 1114.45 503.382 1114.88 502.835C1115.42 502.235 1116.09 501.761 1116.83 501.449C1117.58 501.136 1118.39 500.992 1119.19 501.027H1129.36C1131.06 501.027 1132.21 501.482 1132.81 502.379C1133.11 502.854 1133.27 503.4 1133.29 503.959C1132.99 504.053 1132.69 504.163 1132.4 504.29C1132.31 504.329 1132.25 504.394 1132.21 504.476C1132.17 504.557 1132.16 504.649 1132.18 504.738C1132.2 504.827 1132.24 504.906 1132.31 504.963C1132.38 505.02 1132.47 505.052 1132.56 505.052C1132.62 505.052 1132.68 505.04 1132.73 505.016C1132.74 505.016 1132.94 504.923 1133.27 504.809C1133.17 505.723 1132.93 506.617 1132.57 507.464ZM1158.34 506.749C1157.74 509.691 1155.53 511.571 1151.76 512.337C1149.9 512.69 1148 512.779 1146.12 512.601H1146.08C1143.28 512.601 1141.3 510.97 1139.83 507.467C1139.47 506.599 1139.23 505.682 1139.13 504.745C1139.33 504.824 1139.52 504.913 1139.71 505.011C1139.8 505.055 1139.91 505.061 1140 505.029C1140.1 504.997 1140.18 504.928 1140.23 504.838C1140.28 504.747 1140.29 504.641 1140.26 504.543C1140.24 504.444 1140.17 504.359 1140.08 504.306C1139.77 504.146 1139.45 504.009 1139.12 503.896C1139.15 503.36 1139.31 502.84 1139.6 502.385C1140.2 501.485 1141.36 501.033 1143.05 501.033H1153.21C1154.02 500.998 1154.83 501.142 1155.58 501.455C1156.32 501.767 1156.99 502.241 1157.53 502.841C1157.96 503.389 1158.25 504.025 1158.39 504.702C1158.53 505.379 1158.51 506.079 1158.34 506.748V506.749Z"
      fill="#2C3A64"
    />
    <path
      d="M1113 408.102L1106.42 412.824L1099.79 408.153C1100.54 407.098 1101.53 406.237 1102.67 405.641C1103.82 405.045 1105.09 404.731 1106.39 404.726C1107.68 404.721 1108.95 405.025 1110.1 405.612C1111.25 406.199 1112.25 407.053 1113 408.102Z"
      fill="white"
    />
    <path
      d="M1106.42 393.22C1103.28 393.219 1100.18 393.975 1097.39 395.423C1094.6 396.871 1092.2 398.969 1090.39 401.539L1094.57 404.471C1095.91 402.582 1097.67 401.039 1099.72 399.972C1101.78 398.904 1104.05 398.343 1106.36 398.334C1108.68 398.326 1110.96 398.871 1113.02 399.924C1115.07 400.977 1116.85 402.507 1118.2 404.386L1122.36 401.403C1120.55 398.871 1118.15 396.807 1115.38 395.384C1112.61 393.961 1109.54 393.219 1106.42 393.22Z"
      fill="white"
    />
    <path
      d="M1106.42 371.348C1099.77 371.345 1093.22 372.942 1087.31 376.004C1081.41 379.066 1076.33 383.503 1072.5 388.941L1076.69 391.873C1080.03 387.13 1084.47 383.256 1089.62 380.575C1094.76 377.894 1100.48 376.484 1106.29 376.463C1112.09 376.441 1117.82 377.808 1122.99 380.45C1128.16 383.093 1132.62 386.933 1136 391.651L1140.15 388.668C1136.31 383.306 1131.25 378.938 1125.38 375.926C1119.51 372.913 1113.01 371.344 1106.42 371.348Z"
      fill="white"
    />
    <path
      d="M1106.42 383.315C1101.68 383.313 1097.02 384.445 1092.81 386.616C1088.6 388.787 1084.98 391.934 1082.23 395.794L1086.42 398.727C1088.68 395.555 1091.67 392.967 1095.13 391.177C1098.59 389.386 1102.43 388.445 1106.33 388.43C1110.23 388.415 1114.07 389.327 1117.55 391.09C1121.03 392.854 1124.03 395.419 1126.32 398.573L1130.47 395.607C1127.72 391.8 1124.11 388.7 1119.93 386.563C1115.74 384.426 1111.12 383.313 1106.42 383.315Z"
      fill="white"
    />
    <path
      d="M418.095 517.036C418.095 517.036 408.321 499.689 418.095 496.16C427.869 492.631 432.29 495.885 432.756 499.837C433.222 503.789 429.032 519.36 429.032 519.36L418.095 517.036Z"
      fill="#FFB27D"
    />
    <path
      d="M425.928 627.98C409.754 630.925 393.375 632.605 376.939 633.004C364.363 633.307 351.782 632.742 339.283 631.313C336.323 630.974 333.478 630.596 330.747 630.178C301.897 625.809 285.966 618.06 285.966 618.06C285.966 618.06 312.327 562.948 333.618 565.06C358.601 567.547 400.934 589.938 405.141 583.66C409.88 576.585 413.841 515.909 413.841 515.909C424.917 508.332 431.531 516.318 431.531 516.318C431.531 516.318 453.172 623.071 425.928 627.98Z"
      fill="#F99746"
    />
    <path
      d="M425.928 627.98C409.754 630.925 393.375 632.605 376.939 633.004C364.363 633.307 351.782 632.742 339.283 631.313C332.637 610.199 327.857 588.636 341.224 601.637C364.806 624.568 425.928 627.98 425.928 627.98Z"
      fill="#ED7D2B"
    />
    <path
      d="M283.966 1072.96C283.966 1072.96 282.066 1094.87 286.707 1097.15L346.048 1097.03C346.048 1097.03 346.048 1090.18 336.517 1088.67C326.986 1087.15 310.242 1081.57 307.409 1069.16C304.576 1056.74 283.966 1072.96 283.966 1072.96Z"
      fill="#233862"
    />
    <path
      d="M327.532 807.791C327.239 822.117 326.55 836.891 325.2 850.175C318.792 913.194 316.539 989.335 315.618 1004.02C314.018 1029.5 308.98 1070.21 308.98 1070.21C308.98 1070.21 298.98 1079.69 279.497 1075.16C279.497 1075.16 263.353 1016.53 259.745 954.788C259.689 953.774 259.634 952.758 259.582 951.738C259.163 943.575 258.726 934.238 258.282 924.177C255.313 856.766 252.088 756.625 252.088 756.625L326.552 739.161C326.552 739.161 328.263 772.077 327.532 807.791Z"
      fill="#2A4E96"
    />
    <path
      d="M258.279 924.178C255.31 856.767 252.085 756.626 252.085 756.626L326.549 739.162C326.549 739.162 272.689 900.23 258.279 924.178Z"
      fill="#233862"
    />
    <path
      d="M138.986 744.795C138.986 744.795 126.869 759.027 125.779 762.974C124.689 766.921 122.749 781.138 123.787 785.41C124.825 789.682 132.887 773.497 135.813 771.769C138.739 770.041 133.613 778.207 134.613 779.569C135.613 780.931 141.401 774.803 143.657 772.728C145.913 770.653 145.69 759.492 148.399 752.89C151.108 746.288 138.986 744.795 138.986 744.795Z"
      fill="#FFB27D"
    />
    <path
      d="M136.143 1048.06C136.143 1048.06 125.581 1057.69 127.643 1064.53C129.705 1071.37 139.235 1075.93 140.523 1084.29C141.811 1092.65 146.963 1097.21 151.599 1097.21H173.706C173.706 1097.21 177.119 1091.32 168.876 1089.55C160.633 1087.78 157.524 1077.95 158.04 1068.83C158.254 1061.73 157.996 1054.62 157.267 1047.55L139.75 1043.5L136.143 1048.06Z"
      fill="#233862"
    />
    <path
      d="M314.819 758.151C314.819 758.151 245.112 907.118 208.019 972.481C170.926 1037.84 159.333 1056.08 159.333 1056.08C159.333 1056.08 138.081 1047.72 136.149 1042.02C136.149 1042.02 150.334 915.834 175.175 885.074C189.212 867.693 205.701 815.532 206.475 797.291C207.249 779.05 223.532 735.514 223.532 735.514L314.819 758.151Z"
      fill="#2A4E96"
    />
    <path
      d="M335.195 765.177C335.195 765.177 307.474 783.687 268.242 781.968C251.024 781.216 216.87 776.341 211.358 762.668C210.064 759.458 211.012 755.381 212.958 749.127C217.996 732.87 229.741 701.913 226.195 633.273C225.867 627.266 226.021 621.243 226.656 615.26C230.351 581.45 249.75 561.428 268.501 554.886C314.229 538.922 329.472 561.038 329.472 561.038C329.472 561.038 349.686 577.032 352.732 610.412C358.819 677.176 335.195 765.177 335.195 765.177Z"
      fill="#F99746"
    />
    <path
      d="M281.896 551.046C281.896 551.046 302.877 563.791 325.635 560.188C325.635 560.188 330.135 559.046 327.922 553.769C328.722 551.462 329.397 549.112 329.942 546.731C331.022 542.955 331.892 539.122 332.547 535.249L319.633 521.69L307.401 508.73C304.019 539.702 281.896 551.046 281.896 551.046Z"
      fill="#FFB27D"
    />
    <path
      d="M305.442 520.48C305.442 520.48 312.47 539.242 329.942 546.731C331.942 539.449 333.236 531.832 333.236 531.832L319.636 521.689L305.442 520.48Z"
      fill="#ED985F"
    />
    <path
      d="M347.037 534.595C347.037 534.595 306.987 539.595 304.176 515.013C301.365 490.431 294.301 474.521 319.754 470.289C345.207 466.057 351.254 474.889 354.223 482.876C357.192 490.863 357.382 532.661 347.037 534.595Z"
      fill="#FFB27D"
    />
    <path
      d="M291.532 466.293C291.186 465.866 290.365 465.5 288.515 465.329C289.597 464.769 290.798 464.48 292.015 464.485C292.501 461.924 294.045 457.416 298.526 456.476C297.788 456.871 297.149 457.427 296.655 458.104C296.162 458.78 295.828 459.559 295.677 460.382C301.018 455.303 312.177 451.882 342.594 455.437C382.677 460.125 368.454 485.337 363.134 488.202C357.814 491.067 345.034 482.173 335.304 482.576C325.574 482.979 323.204 496.904 319.841 498.701C316.478 500.498 317.901 497.15 313.525 494.972C309.149 492.794 308.449 500.145 309.552 504.983C310.655 509.821 304.301 515.909 304.301 515.909L298.373 509.028C292.444 502.147 287.686 473.768 290.723 467.872C290.992 467.351 291.258 466.824 291.532 466.293Z"
      fill="#1D2A49"
    />
    <path
      d="M413.845 505.53L345.854 506.13L345.389 495.914L413.169 490.667L413.845 505.53Z"
      fill="#2A4E96"
    />
    <path
      d="M465.17 507.23L391.143 508.299L390.299 489.73L464.115 484.017L465.17 507.23Z"
      fill="#2A4E96"
    />
    <path
      d="M515.086 508.692L452.661 508.77L451.521 483.694L513.692 478.044L515.086 508.692Z"
      fill="#233862"
    />
    <path
      d="M515.978 512.925C516.436 512.905 516.885 512.795 517.3 512.601C517.715 512.406 518.088 512.133 518.397 511.794C518.706 511.456 518.945 511.061 519.101 510.63C519.257 510.199 519.327 509.742 519.306 509.284L517.841 477.073C517.82 476.616 517.71 476.167 517.515 475.752C517.32 475.337 517.046 474.965 516.708 474.656C516.369 474.347 515.973 474.108 515.542 473.952C515.111 473.796 514.654 473.727 514.196 473.748C513.739 473.769 513.29 473.879 512.875 474.073C512.46 474.267 512.087 474.541 511.778 474.879C511.469 475.217 511.229 475.613 511.073 476.044C510.917 476.474 510.847 476.932 510.867 477.389L512.332 509.6C512.353 510.058 512.464 510.507 512.659 510.922C512.853 511.337 513.128 511.71 513.466 512.018C513.805 512.327 514.201 512.566 514.632 512.722C515.063 512.877 515.521 512.947 515.978 512.925Z"
      fill="#233862"
    />
    <path
      d="M345.642 508.314C345.235 508.333 344.829 508.272 344.446 508.133C344.063 507.995 343.711 507.782 343.41 507.508C343.109 507.233 342.865 506.902 342.692 506.533C342.519 506.165 342.421 505.765 342.402 505.358L342.019 497C342.001 496.594 342.063 496.187 342.202 495.805C342.341 495.422 342.553 495.07 342.828 494.77C343.103 494.469 343.434 494.226 343.803 494.053C344.172 493.881 344.571 493.783 344.977 493.764C345.384 493.746 345.791 493.807 346.174 493.945C346.557 494.084 346.909 494.296 347.21 494.571C347.511 494.846 347.755 495.177 347.928 495.545C348.1 495.914 348.199 496.314 348.217 496.72L348.597 505.079C348.634 505.9 348.343 506.702 347.789 507.308C347.235 507.915 346.463 508.277 345.642 508.314Z"
      fill="#2A4E96"
    />
    <path
      d="M212.954 749.123C217.992 732.866 229.737 701.909 226.191 633.269C225.863 627.262 226.017 621.239 226.652 615.256C241.701 613.964 264.704 630.213 264.704 630.213C264.704 630.213 250.542 716.48 212.954 749.123Z"
      fill="#ED7D2B"
    />
    <path
      d="M281.896 551.046C281.896 551.046 243.309 557.671 223.183 582.211C203.057 606.751 170.683 641.354 163.029 653.47C155.375 665.586 134.129 748.047 134.129 748.047C134.129 748.047 135.529 750.699 141.392 752.241C144.611 753.149 148.049 752.86 151.07 751.428C151.07 751.428 179.223 703.306 189.818 679.266C194.218 669.277 270.353 629.721 298.975 633.82C310.213 635.43 281.896 551.046 281.896 551.046Z"
      fill="#F99746"
    />
    <path
      d="M413.44 487.745C413.44 487.745 421.74 492.815 426.704 490.669C431.668 488.523 431.231 486.56 431.231 486.56C431.231 486.56 416.233 482.404 413.44 487.745Z"
      fill="#FFB27D"
    />
    <path
      d="M319.339 577.93C319.339 577.93 302.405 684.715 182.254 715.806L169.166 741.597L192.159 745.484C192.159 745.484 328.946 705.903 327.104 576.042L319.339 577.93Z"
      fill="#E84243"
    />
    <path
      d="M316.719 560.886L311.173 561.428V569.447L319.344 577.93L327.113 576.042V564.914L321.528 560.886H316.719Z"
      fill="#D63A3A"
    />
    <path
      d="M294.951 539.65C294.951 539.65 289.583 540.859 277.31 551.05C277.31 551.05 289.516 576.927 315.268 580.026C315.268 580.026 314.853 568.017 316.714 560.89C316.719 560.886 296.303 553.588 294.951 539.65Z"
      fill="#ED7D2B"
    />
    <path
      d="M316.719 560.886C316.719 560.886 329.285 567.548 330.219 577.93C330.219 577.93 335.019 570.33 333.63 565.065C332.241 559.8 327.93 553.765 327.93 553.765C327.93 553.765 328.349 560.111 316.719 560.886Z"
      fill="#ED7D2B"
    />
    <path
      d="M605.154 314.552C592.685 337.252 576.954 347.258 576.954 347.258L509.054 347.571C509.054 347.571 614.666 297.23 605.154 314.552Z"
      fill="#233862"
    />
    <path
      d="M556.693 489.253C555.903 490.156 555.389 491.268 555.215 492.456C555.041 493.643 555.214 494.856 555.712 495.947C555.714 495.96 555.72 495.972 555.729 495.98C557.429 500.396 562.851 505.258 569.129 510.097C569.929 510.719 570.645 511.284 571.269 511.809C571.432 511.946 571.597 512.084 571.75 512.223C571.877 512.329 571.999 512.442 572.12 512.544C577.992 517.744 575.846 518.999 586.42 529.569C598.477 541.613 606.615 541.669 608.906 540.509C610.844 539.517 606.739 533.085 602.187 525.853C601.967 525.504 601.75 525.153 601.524 524.798C600.918 523.837 600.315 522.861 599.713 521.898C594.375 513.192 595.619 509.034 596.584 495.898C597.369 485.226 611.999 436.061 611.999 436.061L589.283 432.612C589.283 432.612 583.234 471.651 575.841 477.791C571.887 481.064 567.391 481.191 563.577 483.636C563.307 483.806 563.043 483.98 562.784 484.159C560.535 485.577 558.487 487.29 556.693 489.253Z"
      fill="#FFB27D"
    />
    <path
      d="M556.693 489.253C555.903 490.156 555.389 491.268 555.215 492.456C555.041 493.643 555.214 494.856 555.712 495.947C555.714 495.96 555.72 495.972 555.729 495.98C557.79 500.38 563.079 505.225 569.154 510.051C569.948 510.683 570.654 511.264 571.273 511.809C571.436 511.946 571.601 512.084 571.754 512.223C571.881 512.329 572.003 512.442 572.124 512.544C577.996 517.744 575.85 518.999 586.424 529.569C598.481 541.613 606.619 541.669 608.91 540.509C610.848 539.517 606.743 533.085 602.191 525.853C593.865 522.796 586.495 517.592 580.826 510.77C573.534 501.843 568.558 490.288 563.581 483.635C563.311 483.805 563.047 483.979 562.788 484.158C560.538 485.576 558.488 487.29 556.693 489.253Z"
      fill="#233862"
    />
    <path
      d="M738.965 471.53C740.501 478.482 750.44 477.12 761.514 474.186C772.588 471.252 770.008 474.531 785.814 472.467C801.62 470.403 806.3 464.41 806.737 462.049C807.128 459.949 799.287 459.371 790.873 458.571C789.815 458.471 788.753 458.364 787.689 458.254C778.189 457.254 771.127 451.281 762.418 446.435C754.17 441.844 741.618 422.723 741.618 422.723L719.93 424.869C719.93 424.869 731.671 441.937 736.23 449.369C738.911 453.739 738.889 459.59 738.654 464.112C738.427 466.588 738.531 469.082 738.965 471.53Z"
      fill="#FFB27D"
    />
    <path
      d="M761.514 474.186C772.59 471.25 770.008 474.531 785.814 472.467C801.62 470.403 806.3 464.41 806.737 462.049C807.128 459.949 799.287 459.371 790.873 458.571L790.798 458.734C784.097 463.219 776.307 465.807 768.254 466.223C757.513 466.696 746.071 463.846 738.654 464.112C738.428 466.588 738.533 469.083 738.968 471.531C740.501 478.482 750.439 477.121 761.514 474.186Z"
      fill="#233862"
    />
    <path
      d="M652.98 334.444L633.752 389.42L608.652 461.201C603.926 461.647 599.159 461.307 594.543 460.194C588.163 458.488 580.791 453.841 580.791 453.841C580.791 453.841 586.64 377.184 599.504 332.992C602.804 321.649 606.564 312.452 610.815 307.233C631.604 281.686 652.98 334.444 652.98 334.444Z"
      fill="#233862"
    />
    <path
      d="M630.619 248.179C617.231 244.156 579.398 250.407 541.431 258.61L533.191 245.621L450.739 240.821C450.739 240.821 424.762 301.528 440.393 339.575C442.693 345.167 446.741 348.168 454.147 348.141C454.147 348.141 458.702 347.9 458.705 347.903C458.708 347.906 504.711 347.65 520.622 347.336C561.563 346.529 606.713 317.519 612.602 316.221C622.241 314.097 626.494 333.352 636.573 353.459C646.652 373.566 729.319 441.559 729.319 441.559C729.319 441.559 741.819 441.437 746.938 439.402C752.448 437.214 754.424 434.473 754.424 434.473C754.424 434.473 660.812 257.254 630.619 248.179Z"
      fill="#2B478B"
    />
    <path
      d="M519.673 4.3305C514.837 1.58575 509.317 0.277549 503.763 0.559478C501.134 0.656856 498.5 0.536117 495.89 0.198486C464.611 -3.37351 446.73 42.2735 445.897 56.0135C444.362 81.3405 431.045 85.4605 412.506 101.668C375.334 134.168 387.148 170.849 408.088 184.151C420.652 192.133 442.349 183.474 442.349 183.474C442.662 183.683 501.474 149.088 530.471 132.387C574.295 125.286 537.536 14.4855 519.673 4.3305Z"
      fill="#233862"
    />
    <path
      d="M505.626 119.156C505.757 119.236 491.302 124.486 481.486 120.374C472.251 116.514 465.019 101.607 465.155 101.597C469.315 101.322 473.815 97.5965 476.865 73.6646L478.651 74.2646L508.679 84.3925C508.679 84.3925 506.708 93.9925 505.49 103.116C504.465 110.777 503.977 118.107 505.626 119.156Z"
      fill="#FFB27D"
    />
    <path
      d="M508.679 84.3925C508.679 84.3925 506.708 93.9925 505.49 103.116C488.304 100.376 481.246 83.4646 478.651 74.2646L508.679 84.3925Z"
      fill="#ED975D"
    />
    <path
      d="M513.307 93.7881C513.307 93.7881 472.407 89.1241 475.707 63.7281C479.007 38.3321 475.951 20.6282 502.207 22.5282C528.463 24.4282 532.266 34.7792 533.228 43.5282C534.19 52.2772 524.031 94.3471 513.307 93.7881Z"
      fill="#FFB27D"
    />
    <path
      d="M531.463 29.6764C531.463 29.6764 505.793 52.6684 488.063 54.8304C470.333 56.9924 463.499 51.4304 463.499 51.4304C470.461 44.9557 476.017 37.1179 479.82 28.4044C480.686 26.3547 482.083 24.5735 483.868 23.2449C485.652 21.9163 487.76 21.0886 489.971 20.8474C502.638 19.5054 526.672 18.5304 531.463 29.6764Z"
      fill="#233862"
    />
    <path
      d="M515.099 27.9853C515.099 27.9853 523.999 36.2502 526.877 42.4532C529.651 48.4402 530.733 62.8663 528.732 68.6443C528.732 68.6443 541.821 41.9442 533.861 29.2502C525.419 15.7922 515.099 27.9853 515.099 27.9853Z"
      fill="#233862"
    />
    <path
      d="M541.163 178.497C541.563 260.997 542.114 243.746 533.236 251.75C531.097 253.677 525.001 254.921 516.958 255.611C491.671 257.789 447.078 254.5 445.293 249.859C439.133 233.803 443.156 228.698 437.793 204.035C437.233 201.412 436.548 198.574 435.749 195.485C431.349 178.561 427.281 172.853 441.155 145.25C453.737 120.25 466.919 99.8932 468.155 100.593C503.046 120.36 505.487 103.119 505.487 103.119C505.487 103.119 540.973 138.256 541.163 178.497Z"
      fill="#00B0B7"
    />
    <path
      d="M633.752 389.42L608.652 461.201C603.926 461.647 599.159 461.307 594.543 460.194C588.163 458.488 580.791 453.841 580.791 453.841C580.791 453.841 586.64 377.184 599.504 332.992L633.752 389.42Z"
      fill="#2B478B"
    />
    <path
      d="M505.49 103.116C505.49 103.116 541.09 108.424 545.562 123.602C550.034 138.78 576.325 228.002 576.325 228.002C576.325 228.002 558.35 231.594 549.851 223.435C541.352 215.276 519.327 146.782 519.327 146.782L505.49 103.116Z"
      fill="#00B0B7"
    />
    <path
      d="M516.958 255.611C491.671 257.789 447.078 254.5 445.293 249.859C439.133 233.803 443.156 228.698 437.793 204.035L449.327 169.446C449.327 169.446 448.064 207.735 459.556 217.572C471.048 227.409 506.179 236.081 511.836 244.378C514.285 247.738 516.028 251.559 516.958 255.611Z"
      fill="#009191"
    />
    <path
      d="M487.63 240.096C487.63 240.096 512.5 234.048 516.575 236.183C520.65 238.318 530.66 246.183 531.948 248.969C533.236 251.755 522.933 247.016 519.595 246.192C517.434 245.658 511.813 247.734 509.03 248.722C497.318 252.881 490.053 251.003 490.053 251.003L487.63 240.096Z"
      fill="#FFB27D"
    />
    <path
      d="M468.135 100.576C468.135 100.576 434.635 103.302 423.343 119.707C407.443 142.799 376.943 240.477 395.78 253.053C416.996 267.215 491.1 254.988 491.1 254.988C491.1 254.988 493.346 243.388 489.794 237.876C486.242 232.364 430.146 224.439 427.515 221.912C424.884 219.385 458.781 171.012 458.629 163.277C458.477 155.542 468.135 100.576 468.135 100.576Z"
      fill="#00B0B7"
    />
    <path
      d="M517.919 243.103C517.919 243.103 523.286 249.743 525.019 250.514C525.893 250.965 526.877 251.156 527.855 251.062L524.203 244.792L517.919 243.103Z"
      fill="#FFB27D"
    />
    <path
      d="M516.574 236.183L531.938 243.264C531.647 243.638 531.263 243.929 530.825 244.108C530.386 244.288 529.908 244.349 529.438 244.286C527.563 244.238 522.802 242.604 522.802 242.604L516.574 236.183Z"
      fill="#FFB27D"
    />
    <path
      d="M525.224 260.845L645.6 258.471L680.033 167.818L559.842 170.188L525.224 260.845Z"
      fill="#F99746"
    />
    <path
      d="M646.942 254.939L487.985 258.074L488.054 261.574L645.601 258.467L646.942 254.939Z"
      fill="#ED7D2B"
    />
    <path
      d="M614.324 214.1C615.169 210.921 613.288 208.394 610.124 208.456C608.461 208.582 606.875 209.21 605.578 210.259C604.281 211.308 603.334 212.726 602.862 214.326C602.017 217.505 603.898 220.032 607.062 219.97C608.726 219.845 610.312 219.217 611.609 218.168C612.906 217.119 613.853 215.701 614.324 214.1Z"
      fill="white"
    />
    <path
      d="M386.419 1055.1H1782.28C1784.6 1055.1 1786.89 1055.55 1789.04 1056.44C1791.18 1057.32 1793.12 1058.62 1794.76 1060.26C1796.4 1061.9 1797.7 1063.84 1798.59 1065.98C1799.48 1068.12 1799.94 1070.42 1799.94 1072.74V1076.59C1799.94 1078.91 1799.48 1081.2 1798.59 1083.34C1797.7 1085.49 1796.4 1087.43 1794.76 1089.07C1793.11 1090.71 1791.17 1092 1789.02 1092.89C1786.88 1093.77 1784.58 1094.23 1782.26 1094.22L385.976 1092.66C383.389 1092.66 380.833 1092.09 378.49 1090.99C376.148 1089.89 374.076 1088.29 372.421 1086.3C370.766 1084.31 369.569 1081.98 368.915 1079.48C368.261 1076.97 368.165 1074.36 368.635 1071.81L369.059 1069.52C369.813 1065.47 371.962 1061.81 375.133 1059.18C378.304 1056.54 382.297 1055.1 386.419 1055.1Z"
      fill="#233862"
    />
  </svg>
);
